function u(s) {
  let r, i = 0;
  return (e) => {
    const m = async (t) => {
      const n = t.querySelectorAll("pre code.language-mermaid");
      if (!n.length) return;
      const l = await import("../mermaid.core-cSWK5aGH.js").then((a) => a.bE);
      r ?? (r = l.default), r.initialize({
        startOnLoad: !1,
        theme: document.documentElement.classList.contains("dark") ? "dark" : "default",
        ...s
      }), await Promise.all(Array.from(n).map(async (a) => {
        const d = a.closest("pre"), { svg: p } = await r.render(`m-${i++}`, a.textContent || ""), o = document.createElement("div");
        o.className = "marzipan-mermaid", o.innerHTML = p, d.replaceWith(o);
      }));
    }, c = e.options.hooks?.afterPreviewRender;
    e.options.hooks = e.options.hooks || {}, e.options.hooks.afterPreviewRender = (t, n) => {
      c?.(t, n), m(t);
    };
  };
}
export {
  u as mermaidPlugin
};
//# sourceMappingURL=mermaidPlugin.js.map
